module.exports = __webpack_public_path__ + "static/media/section_1_A.b7343ce4.png";